import React from 'react';
import {AgGridReact} from 'ag-grid-react';
import styled from 'styled-components';
import '../../componentes/componentes_generales/grid/ag_grid.css';
import '../../componentes/componentes_generales/grid/theme_silver.css';
import GridDetCheques from './form_banco05_gridDistribDet';
import DecimalRenderer from '../../componentes/componentes_generales/grid/col_render_numerodecimal';

const ContenedorGridDistrib = styled.div`
  width: 100%;
  height: ${props => props.altura};
  margin-bottom: 10px;
  margin-top: 10px;
`;

export default class GridDistribDepositoCheques extends React.Component{
  
  constructor(props) {
    super(props);
    this.state = {      
      columnsDefGridChequesDistrib:[
        { headerName: "Cód. Cta. Depositar",
          field: "CodCuentaDepositar",
          width: 130,
          cellRenderer: 'group',
          cellRendererParams: {suppressCount: true}
        },
        { headerName: "Descrip. Cta. Depositar",
          field: "DescripCuentaDepositar",
          width: 250,
        },
        { headerName: "No. Cheques",
          field: "NroCheques",
          width: 100,
        },
        { headerName: "Total",
          field: "Total",
          width: 100,
          cellRendererFramework: DecimalRenderer
        },
      ]
    };
    
    this.onGridChequesDistribReady = this.onGridChequesDistribReady.bind(this);    
  }

  onGridChequesDistribReady(params) {
    this.apiGridChequesDistrib = params.api;
    this.columnApiGridChequesDistrib = params.columnApi;
    this.apiGridChequesDistrib.sizeColumnsToFit();
  }

  isFullWidthCell(rowNode) {
    return rowNode.level === 1;
  }

  getRowHeight(params) {
    let rowIsDetailRow = params.node.level === 1;    
    return rowIsDetailRow ? 225 : 25;
  }

  getNodeChildDetails(record) {
    if (record.Cheques) {
        return {
            group: true,            
            key: record.CodCuentaDepositar,
            children: [record.Cheques]
        };
    } else {
        return null;
    }
  }

  render(){  
    return(
      <ContenedorGridDistrib altura={this.props.altura} className='ag-silver'>
        <AgGridReact
          suppressMovableColumns={true}
          columnDefs={this.state.columnsDefGridChequesDistrib}
          rowData={this.props.distribucionDepositoCheques}
          isFullWidthCell={this.isFullWidthCell}
          getRowHeight={this.getRowHeight}
          getNodeChildDetails={this.getNodeChildDetails}
          fullWidthCellRendererFramework={GridDetCheques}
          onGridReady={this.onGridChequesDistribReady}
          enableSorting
          enableColResize
          enableFilter          
        >        
        </AgGridReact>
      </ContenedorGridDistrib>
    )         
  }  
}